// ======================================================
// FILE: src/utils/profileSaveSafe.js   (PRODUCTION)
// ======================================================
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getAuth } from "firebase/auth";

// Client must not set privileged fields from the app.
const BLOCKED_KEYS = new Set([
  "managerOnly",
  "role",
  "plan",
  "subscription",
  "subscriptionStatus",
  "readOnly",
  "isPaid",
  "isManager",
  "admin",
]);

/**
 * Save current user's profile safely to /users/{uid}.
 * - Strips forbidden keys
 * - Always sets uid
 * - merge:true to avoid overwriting unrelated fields
 */
export async function saveUserProfileSafe(partial, opts = {}) {
  const auth = getAuth();
  const u = auth.currentUser;
  if (!u) throw new Error("Not signed in");
  if (opts.readOnly) throw new Error("Read-only accounts cannot update profile.");

  const allowed = {};
  for (const [k, v] of Object.entries(partial || {})) {
    if (!BLOCKED_KEYS.has(k) && v !== undefined) {
      allowed[k] = v;
    }
  }
  allowed.uid = u.uid;

  const ref = doc(db, "users", u.uid);
  await setDoc(ref, allowed, { merge: true });
}
